var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterListThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0009 24.3131C14.9742 24.596 13.8599 24.7511 12.6607 24.7511V24.7479C10.3923 24.7509 8.17086 24.101 6.26172 22.8759C6.59152 22.9154 6.92335 22.9355 7.25551 22.9361C9.13569 22.938 10.9619 22.3073 12.4401 21.1455C11.5689 21.1291 10.7246 20.8409 10.0253 20.3211C9.32599 19.8013 8.80663 19.0759 8.53986 18.2463C9.16542 18.3668 9.81027 18.3423 10.4249 18.1747C9.48012 17.9839 8.63045 17.4721 8.02 16.7262C7.40955 15.9803 7.0759 15.0462 7.07563 14.0824V14.0295C7.65618 14.3531 8.30606 14.5323 8.97042 14.552C8.08653 13.9618 7.46082 13.0568 7.22069 12.0215C6.98057 10.9861 7.14408 9.89817 7.67793 8.97913C8.72611 10.2687 10.0338 11.3235 11.516 12.0749C12.9983 12.8264 14.622 13.2577 16.2818 13.3409C16.0741 12.4459 16.1671 11.5074 16.5465 10.6706C16.9259 9.83385 17.5705 9.14543 18.3805 8.7119C19.1906 8.27838 20.1209 8.12392 21.0276 8.27242C21.9343 8.42092 22.7668 8.86411 23.3962 9.5334C24.3311 9.34906 25.2276 9.00636 26.0471 8.52008C25.7355 9.48682 25.0833 10.3074 24.2118 10.8292C25.0394 10.7313 25.8476 10.5099 26.6095 10.1723C26.049 11.0106 25.3438 11.7423 24.5267 12.3333C24.5389 12.5123 24.5389 12.6922 24.5389 12.8729C24.5389 13.9015 24.393 14.9594 24.1056 16H17.3922C16.6238 16 16.0009 16.6229 16.0009 17.3913V24.3131Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3926 22.9565C17.3926 22.5723 17.704 22.2609 18.0882 22.2609L23.6534 22.2609C24.0376 22.2609 24.3491 22.5723 24.3491 22.9565C24.3491 23.3407 24.0376 23.6522 23.6534 23.6522L18.0882 23.6522C17.704 23.6522 17.3926 23.3407 17.3926 22.9565Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3926 20.5218C17.3926 20.1376 17.704 19.8261 18.0882 19.8261L23.6534 19.8261C24.0376 19.8261 24.3491 20.1376 24.3491 20.5218C24.3491 20.906 24.0376 21.2174 23.6534 21.2174L18.0882 21.2174C17.704 21.2174 17.3926 20.906 17.3926 20.5218Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3926 18.0869C17.3926 17.7028 17.704 17.3913 18.0882 17.3913L23.6534 17.3913C24.0376 17.3913 24.3491 17.7028 24.3491 18.0869C24.3491 18.4711 24.0376 18.7826 23.6534 18.7826L18.0882 18.7826C17.704 18.7826 17.3926 18.4711 17.3926 18.0869Z",
    fill: "white"
  })));
}

export default SvgTwitterListThumb;